/* ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ
   GALA GULAAB ‚Äî theme.js
   ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ */

/* ‚îÄ‚îÄ New Arrivals bidirectional scroll arrows ‚îÄ‚îÄ */
(function () {
  const strip     = document.getElementById('products-scroll');
  const btnL      = document.getElementById('arr-left');
  const btnR      = document.getElementById('arr-right');
  if (!strip || !btnL || !btnR) return;

  const STEP      = 280;   // px per arrow click (‚âà one card + gap)
  const RIGHT_PAD = 15;    // padding-right on strip
  const SCROLL_MS = 1100;  // scroll animation duration (ms)

  /* Custom ease-in-out cubic ‚Äî resistant, deliberate feel */
  function scrollBy(dist) {
    const start  = strip.scrollLeft;
    const maxL   = strip.scrollWidth - strip.clientWidth;
    const target = Math.max(0, Math.min(start + dist, maxL));
    const t0     = performance.now();
    (function tick(now) {
      const p    = Math.min((now - t0) / SCROLL_MS, 1);
      const ease = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      strip.scrollLeft = start + (target - start) * ease;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  function updateArrows() {
    const atStart = strip.scrollLeft <= 2;
    const atEnd   = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - RIGHT_PAD - 1;
    btnL.classList.toggle('is-visible', !atStart);
    btnR.classList.toggle('is-hidden',  atEnd);
  }

  strip.addEventListener('scroll', updateArrows, { passive: true });
  btnR.addEventListener('click', () => scrollBy( STEP));
  btnL.addEventListener('click', () => scrollBy(-STEP));

  updateArrows();
})();

/* ‚îÄ‚îÄ Newsletter form ‚îÄ‚îÄ */
function handleNewsletter(e) {
  e.preventDefault();
  const input = e.target.querySelector('input[type="email"]');
  if (!input || !input.value) return;
  /* Shopify: replace this with your Klaviyo / newsletter app integration */
  alert('Thank you for subscribing!');
  input.value = '';
}

/* ‚îÄ‚îÄ Shared product card swipe carousel ‚îÄ‚îÄ
   Used by any product grid with .js-carousel markup
   (Collection general, Search results, Collection Preview).
   Touch swipe on real mobile, mouse-drag + arrow-keys when the
   viewport itself is mobile-width (so it can be tested on desktop
   via the Theme Editor's mobile preview). Each section sets its own
   mobile breakpoint via the --carousel-mobile-bp CSS variable on
   the .js-carousel element (defaults to 640). */
(function () {
  var hoveredCarousel = null;

  function mobileBreakpoint(carousel) {
    var v = getComputedStyle(carousel).getPropertyValue('--carousel-mobile-bp');
    var n = parseInt(v, 10);
    return isNaN(n) ? 640 : n;
  }

  function isMobileWidth(carousel) {
    return window.innerWidth <= mobileBreakpoint(carousel);
  }

  function initCarousels() {
    document.querySelectorAll('.js-carousel').forEach(function (carousel) {
      var slidesEl = carousel.querySelector('.js-carousel-slides');
      var slideEls = carousel.querySelectorAll('.js-carousel-slide');
      var barEls   = carousel.querySelectorAll('.js-carousel-bar');
      var total    = slideEls.length;
      if (!slidesEl || total <= 1) return;
      var current  = 0;
      var startX   = 0;
      var dragging = false;
      var didSwipe = false;

      function goTo(index) {
        if (index < 0 || index > total - 1) return;
        current = index;
        slidesEl.style.transform = 'translateX(-' + (current * 100) + '%)';
        barEls.forEach(function (b, i) {
          b.classList.toggle('js-carousel-bar--active', i === current);
        });
      }

      function onStart(x) {
        if (!isMobileWidth(carousel)) return;
        startX   = x;
        dragging = true;
        didSwipe = false;
      }

      function onEnd(x) {
        if (!dragging) return;
        dragging = false;
        var dx = x - startX;
        if (Math.abs(dx) > 40) {
          didSwipe = true;
          if (dx < 0) goTo(current + 1);
          else goTo(current - 1);
        }
      }

      carousel.addEventListener('touchstart', function (e) {
        onStart(e.touches[0].clientX);
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        onEnd(e.changedTouches[0].clientX);
      }, { passive: true });

      carousel.addEventListener('mousedown', function (e) {
        if (!isMobileWidth(carousel)) return;
        e.preventDefault();
        onStart(e.clientX);
      });

      window.addEventListener('mouseup', function (e) {
        onEnd(e.clientX);
      });

      carousel.addEventListener('dragstart', function (e) { e.preventDefault(); });

      carousel.addEventListener('mouseenter', function () {
        if (isMobileWidth(carousel)) hoveredCarousel = { goTo: goTo, current: function () { return current; } };
      });
      carousel.addEventListener('mouseleave', function () {
        if (hoveredCarousel && hoveredCarousel.goTo === goTo) hoveredCarousel = null;
      });

      carousel.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          e.stopPropagation();
          didSwipe = false;
        }
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!hoveredCarousel) return;
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      hoveredCarousel.goTo(hoveredCarousel.current() + 1);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      hoveredCarousel.goTo(hoveredCarousel.current() - 1);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();
